/*
 * @Author: bill
 * @Date: 2024-05-21 09:16:03
 * @LastEditors: wangzijun@bzstech.com wangzijun@bzstech.com
 * @LastEditTime: 2024-05-21 09:30:03
 * @FilePath: /study/src/layout/index.tsx
 * @Description:
 */
import React from "react";
import { Routes, Outlet } from "react-router-dom";
import { routeRender } from "../routes";
import { Card } from "antd";

class Layout extends React.Component {
  render(): React.ReactNode {
    return (
      <Card>
        <Routes>{routeRender}</Routes>
        <Outlet />
      </Card>
    );
  }
}

export default Layout;
